module.exports = __webpack_public_path__ + "media/images/icon-ptw@3x-1aba97a3e4ef1539844da7038cf303fa.png";